<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>九火互娱</h3>
          <p class="company-desc">专注于软件开发与游戏运营的技术服务提供商</p>
          <div class="social-links">
            <a title="微信"><i class="fab fa-weixin"></i></a>
            <a title="微博"><i class="fab fa-weibo"></i></a>
            <a title="GitHub"><i class="fab fa-github"></i></a>
          </div>
        </div>

        <div class="footer-section">
          <h3>服务项目</h3>
          <ul class="footer-links">
            <li><a>软件开发</a></li>
            <li><a>游戏运营</a></li>
            <li><a>技术咨询</a></li>
            <li><a>解决方案</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h3>联系我们</h3>
          <ul class="contact-info">
            <li><i class="fas fa-phone"></i> 18249833439</li>
            <li><i class="fas fa-envelope"></i> 9huo@88.com</li>
            <li>
              <i class="fas fa-map-marker-alt"></i>
              北京市丰台区百强大道10号楼12层
            </li>
            <li><i class="far fa-clock"></i> 周一至周五 9:00-18:00</li>
          </ul>
        </div>

        <div class="footer-section">
          <h3>快速链接</h3>
          <ul class="footer-links">
            <li><router-link to="/about">关于我们</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
            <li><router-link to="/products/whatsEatApp">吃啥大管家</router-link></li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-info">
          <p>&copy; 2024 九火互娱</p>
          <p>京ICP备2024066610号-4</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
.footer {
  background-color: #1a1f36;
  color: #a0aec0;
  padding: 60px 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1fr;
  gap: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #2d3748;
}

.footer-section h3 {
  color: #fff;
  font-size: 1.3rem;
  margin-bottom: 20px;
  position: relative;
}

.footer-section h3::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 30px;
  height: 2px;
  background: linear-gradient(90deg, var(--primary-color), var(--primary-dark));
}

.company-desc {
  margin: 15px 0;
  line-height: 1.6;
  color: #cbd5e0;
}

.social-links {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.social-links a {
  color: #a0aec0;
  font-size: 1.5rem;
  transition: all 0.3s ease;
}

.social-links a:hover {
  color: var(--primary-color);
  transform: translateY(-3px);
}

.footer-links {
  list-style: none;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #a0aec0;
  text-decoration: none;
  transition: color 0.3s ease;
  display: inline-block;
}

.footer-links a:hover {
  color: var(--primary-color);
  transform: translateX(5px);
}

.contact-info {
  list-style: none;
}

.contact-info li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  color: #cbd5e0;
}

.contact-info i {
  color: var(--primary-color);
  width: 20px;
}

.footer-bottom {
  padding-top: 20px;
  text-align: center;
}

.footer-info {
  display: flex;
  justify-content: center;
  gap: 20px;
  font-size: 0.9rem;
  color: #718096;
}

@media (max-width: 992px) {
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-section h3::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .social-links {
    justify-content: center;
  }

  .contact-info li {
    justify-content: center;
  }

  .footer-info {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
